module.exports = function(option, success, fail) {
  var data = option.data || {};
  var url = option.url;

  if (data.password) {
    data = JSON.parse(JSON.stringify(data));
    delete data.password;
  }

  $.ajax(option).done(function(ret) {
    success.call(this, ret);
  }).fail(function(err, status, message) {
    fail && fail(err, status, message);
    data.ajaxStatus = status;
    data.ajaxMessage = message;
    if (err) {
      data.ajaxCode = err.status + ': ' + (err.statusText || '');
    }
    

    window.onerror(status + ': ' + message, url, -1, -1, {
      stack: JSON.stringify(data)
    });
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/@enhancer/fe-util-ajax/index.js
// module id = 11
// module chunks = 0